export interface ActivismArea {
	id: number;
	title: string;
	subtitle: string;
	description: string;
	icon: string;
	highlights: string[];
}

export const activismAreas: ActivismArea[] = [
	{
		id: 1,
		title: "Medios de comunicación",
		subtitle: "Participación activa en medios",
		description:
			"Presencia constante en radio, televisión y prensa para dar voz a las realidades sociales, sensibilizar a la opinión pública y trasladar el mensaje de la asociación más allá de los espacios habituales.",
		icon: "IconBroadcast",
		highlights: [
			"Entrevistas en radio y televisión",
			"Artículos y reportajes en prensa",
			"Difusión de campañas de sensibilización",
			"Divulgación sobre derechos e igualdad",
		],
	},
	{
		id: 2,
		title: "Mesas redondas",
		subtitle: "Debate y reflexión colectiva",
		description:
			"Participación en mesas redondas, coloquios y encuentros donde se debaten temas sociales junto a otras voces expertas, generando espacios de diálogo, reflexión y construcción de propuestas compartidas.",
		icon: "IconUsersGroup",
		highlights: [
			"Coloquios y debates públicos",
			"Encuentros con entidades y expertos",
			"Foros sobre igualdad y justicia social",
			"Espacios de diálogo intergeneracional",
		],
	},
];
